import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/:botId',
      name: 'Chat',
      query: {
        userId: '',
        username: '',
        isDebugger: '',
        activeTab: '',
        vlibrasAlreadyOpen: ''
      },
      component: () => import('../screens/chat/index.vue'),
      beforeEnter: (to, from, next) => {
        if (to.params.botId.includes('undefined')) {
          next('/')
        }

        next()
      }
    },
    {
      path: '*',
      name: 'NotFound',
      component: () => import('../screens/notFound/index.vue')
    }
  ]
})
